import { render } from "./g-select-field.vue?vue&type=template&id=39db261c&ts=true"
import script from "./g-select-field.vue?vue&type=script&lang=tsx"
export * from "./g-select-field.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__